/**
 * @generated SignedSource<<adc2088962ffe078a5b587a44442c6d8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ArchiveContactInput = {
  contactID: string;
};
export type contactArchiveContactMutation$variables = {
  input: ArchiveContactInput;
};
export type contactArchiveContactMutation$data = {
  readonly archiveContact: {
    readonly ok: boolean;
  };
};
export type contactArchiveContactMutation = {
  variables: contactArchiveContactMutation$variables;
  response: contactArchiveContactMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ArchiveContactPayload",
    "kind": "LinkedField",
    "name": "archiveContact",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "contactArchiveContactMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "contactArchiveContactMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "7dc722337f12abca0648912ed24d664c",
    "id": null,
    "metadata": {},
    "name": "contactArchiveContactMutation",
    "operationKind": "mutation",
    "text": "mutation contactArchiveContactMutation(\n  $input: ArchiveContactInput!\n) {\n  archiveContact(input: $input) {\n    ok\n  }\n}\n"
  }
};
})();

(node as any).hash = "86a5a6e8ccb2ea5d64c449b58b456972";

export default node;
